import fetchApi from "../fetchApi";
export const CreateProgramReport = async (
  program,
  email,
  report,
  frequency,
  timeRange,
  method
) => {
  const options = {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify({
      email: email,
      report: report,
      frequency: frequency,
      time_range: timeRange,
      reporting_method: method,
    }),
    redirect: "follow",
  };

  return await fetchApi(`card-issuing/company/program-report/${program}`, options);
};
